import { configs } from '@app/configs';
import i18next from 'i18next';
const isLandingPageUrl = (url) => {
    const regex = new RegExp('^http(s)?://(www.)?(dev.)?' + configs.LANDING_PAGE_DOMAIN + '(.*)$');
    return regex.test(url);
};
export const landingPageLanguageReferrer = (supportedLanguages) => {
    const referrer = document === null || document === void 0 ? void 0 : document.referrer;
    if (isLandingPageUrl(referrer)) {
        const path = referrer.split(configs.LANDING_PAGE_DOMAIN)[1];
        const pathWithoutLeadingDot = path.charAt(0) === '.' ? path.substring(1) : path;
        const [startSlash, firstCh, secondCh, endSlash] = [pathWithoutLeadingDot[0], pathWithoutLeadingDot[1], pathWithoutLeadingDot[2], pathWithoutLeadingDot[3]];
        const lang = `${firstCh || ''}${secondCh || ''}`;
        if (startSlash === '/' && (endSlash === '/' || !endSlash) && lang) {
            if (supportedLanguages.indexOf(lang) === -1)
                return;
            i18next.changeLanguage(lang);
        }
        else {
            i18next.changeLanguage('de');
        }
    }
};
